import { gql } from '@apollo/client';
export const getNetworksQuery = gql `
  query GetNetworks {
    getNetworks {
      id
      isEnabled
      name
      iconUrl
    }
  }
`;
//# sourceMappingURL=getNetworks.js.map